import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default function scrollSlider(element) {

    const frameCount = 300;

    const canvas = element.querySelector("#sequence");
    const context = canvas.getContext("2d");

    const leftBlock = element.querySelector(".slides__inner");
    const navItems = element.querySelectorAll(".nav-item");
    const slideItems = element.querySelectorAll(".slide__item");

    const totalSlides = slideItems.length;

    let slideOffsets = [];

    function calculateOffsets() {
        slideOffsets = Array.from(slideItems).map(slide => slide.offsetTop);
    }

    calculateOffsets();
    window.addEventListener("resize", calculateOffsets);

    const isMobile = window.innerWidth < 700;

    const slidesMap = [
        { start: 0, end: 49 },
        { start: 50, end: 99 },
        { start: 100, end: 149 },
        { start: 150, end: 199 },
        { start: 200, end: 249 },
        { start: 250, end: 299 },
    ];

    const dpr = window.devicePixelRatio || 1;

    function resizeCanvas() {
        const rect = canvas.getBoundingClientRect();
        canvas.width = rect.width * dpr;
        canvas.height = rect.height * dpr;
        context.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    // preload images
    const images = [];
    const getSrc = (i) => `/images/scroll-slider/${String(i).padStart(5,'0')}.webp`;

    for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = getSrc(i);
        images.push(img);
    }

    let lastFrame = -1;

    // отрисовка кадров canvas
    function render(frame) {
        if (!images[frame] || frame === lastFrame) return;
        lastFrame = frame;

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(
            images[frame],
            0,
            0,
            canvas.width / dpr,
            canvas.height / dpr
        );
    }

    // обновление активного Nav
    function updateNav(stageIndex) {
        navItems.forEach((el, i) => {
            el.classList.toggle("active", i === stageIndex);
        });
    }

    // обновление активного Slide
    function updateSlide(stageIndex) {
        slideItems.forEach((el, i) => {
            if (isMobile) {
                if (i === stageIndex) {
                    gsap.to(el, { 
                        autoAlpha: 1, 
                        // duration: 0.3 
                    });
                } else {
                    gsap.to(el, { 
                        autoAlpha: 0, 
                        // duration: 0.3 
                    });
                }
            } else {
                el.classList.toggle("active", i === stageIndex);
            }
        });
    }

    // function updateText(progress) {
    //     const totalHeight = leftBlock.scrollHeight;
    //     // const visibleHeight = leftBlock.parentElement.offsetHeight;
    //     // const maxOffset = totalHeight - visibleHeight;  // максимальный сдвиг текста
    //     const maxOffset = totalHeight;  // максимальный сдвиг текста

    //     const y = -progress * maxOffset;

    //     gsap.set(leftBlock, { y });
    // }
    function updateText(progress) {
        const stages = totalSlides;
        const stageSize = 1 / stages;

        let stageIndex = Math.floor(progress / stageSize);
        stageIndex = Math.min(stageIndex, stages - 1);

        let stageProgress = (progress - stageIndex * stageSize) / stageSize;

        const currentOffset = slideOffsets[stageIndex];
        const nextOffset = slideOffsets[stageIndex + 1] ?? currentOffset;

        let y;

        if (stageProgress < 0.3) {
            // движение ВНУТРИ текущей стадии (без предыдущего!)
            const p = stageProgress / 0.3;
            y = -(currentOffset * p + currentOffset * (1 - p)); 
            // по сути просто плавный заход к currentOffset
        } else if (stageProgress < 0.7) {
            // ПЛАТО
            y = -currentOffset;
        } else {
            // движение к следующему
            const p = (stageProgress - 0.7) / 0.3;
            y = -(currentOffset + (nextOffset - currentOffset) * p);
        }

        gsap.set(leftBlock, { y });
    }

    const obj = { progress: 0 };

    images[0].onload = () => {
        render(0); // показать первый кадр
        
        gsap.to(obj, {
            progress: 1,
            ease: "none",
            scrollTrigger: {
                id: "scrollSequence",
                trigger: ".scroll__slider",
                start: "top top",
                end: () => "+=" + window.innerHeight * (totalSlides + 1),
                // scrub: true,
                scrub: 1,
                pin: true,
                invalidateOnRefresh: true,
                onRefresh: () => {
                    document.dispatchEvent(new Event('sliderReady'));
                },
            },
            onUpdate: () => {

                const progress = obj.progress;
                const frame = Math.round(progress * (frameCount - 1)); // текущий кадр
                const stageIndex = getStageIndex(frame); // стадия по кадру

                render(frame);
                updateNav(stageIndex);
                if (!isMobile) {
                    updateText(progress);
                }
                updateSlide(stageIndex);
            }
        });
    };

    // определить стадию по кадру
    function getStageIndex(frame) {
        return slidesMap.findIndex(
            s => frame >= s.start && frame <= s.end
        );
    }

    // навигация по клику
    navItems.forEach((item, index) => {
        item.addEventListener("click", () => {
            const stage = slidesMap[index]; // старотовый кадр стадии
            const targetProgress = stage.start / (frameCount - 1); // прогресс
            const st = ScrollTrigger.getById("scrollSequence");

            // позиция скрола 
            const targetScroll = st.start + targetProgress * (st.end - st.start);

            gsap.to(window, {
                scrollTo: targetScroll,
                duration: 0.3,
                ease: "none"
            });
        });
    });
}